/* global angular */
angular.module('ua5App.index.tag')
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('index.tag', {
            url: 'tag/:tag',
            templateUrl: 'states/index.tag/index.tag.html',
            controller: 'TagCtrl',
            controllerAs: 'ctrl'
        });
    }])
    .controller('TagCtrl', [
    'posts',
    '$filter',
    '$stateParams',
    'MetaFactory',
    function(posts, $filter, $stateParams, MetaFactory) {
        var self = this;
        var skip;
        // Artists to skip
        skip = ['Trisha Donnelly'];
        self.posts = [];
        self.tag = $stateParams.tag;
        angular.forEach(posts, function(post) {
            var artist;
            var slug;
            var year;
            slug = post.slug;
            artist = post.title;
            year = post.acf.birth_year; // jshint ignore:line
            angular.forEach(post.acf.artwork, function(artwork, index) {
                // Add to array if searched tag found in string
                if (artwork.tag.indexOf(self.tag) !== -1  && artwork.image && skip.indexOf(artist) === -1) {
                    self.posts.push({
                        artist: artist,
                        year: artwork.date,
                        image: artwork.image.sizes.medium,
                        imageLarge: artwork.image.sizes.large,
                        tags: artwork.tag.split(/\s*,\s*/),
                        imageIndex: index + 1,
                        slug: slug,
                        imageHeight: artwork.image.sizes['medium-height'],
                        imageWidth: artwork.image.sizes['medium-width'],
                        title: artwork.title
                    });
                }
            });
        });
        // Set meta information
        MetaFactory.set({
            title: $stateParams.tag + ' | Storylines: Contemporary Art at the Guggenheim',
            ogTitle: $stateParams.tag + ' | Storylines: Contemporary Art at the Guggenheim'
        });
    }])
;
